import * as React from 'react';
import { DefaultButton, PrimaryButton, SpinButton } from "@fluentui/react";
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddPaymentRetention(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [percentage, setPercentage] = useState(5);
    const [delay, setDelay] = useState(30);

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, percentage: percentage, delay: delay};
        fetch(`/api/agreement/${props.add}/retention`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddPaymentRetention'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName('');
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Zatrzymanie Płatności"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddPaymentRetention'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <SpinButton
                    label={'Procent:'}
                    labelPosition={'top'}
                    min={0}
                    step={0.1}
                    incrementButtonAriaLabel={'+0.1'}
                    decrementButtonAriaLabel={'-0.1'}
                    value={percentage}
                    onChange={(e, val) => setPercentage(e.target.value || val || '')}
                />
                <SpinButton
                    label={'Dni Karencji:'}
                    labelPosition={'top'}
                    min={0}
                    step={1}
                    incrementButtonAriaLabel={'+1'}
                    decrementButtonAriaLabel={'-1'}
                    value={delay}
                    onChange={(e, val) => setDelay(e.target.value || val || '')}
                />
            </form>
        </Panel>
    )
}

export default AddPaymentRetention;